"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var styles = require("./DropdownButton.scss");
var key_press_1 = require("../../../utils/key-press");
var DropdownButton = React.forwardRef(function (_a, ref) {
    var data = _a.data, _b = _a.events, events = _b === void 0 ? {} : _b, options = _a.options, testId = _a.testId, uniqueId = _a.uniqueId;
    var menuOptions = options.menuOptions;
    var onBlur = events.onBlur, onChange = events.onChange, onFocus = events.onFocus, onKeyDown = events.onKeyDown;
    var dataOptionsRef = __spread(Array(menuOptions.length)).map(function (_, i) { return i; });
    var buttonRef = React.createRef();
    var buttonSize = data.buttonSize, buttonTitle = data.buttonTitle, disabled = data.disabled;
    var _c = __read(React.useState({
        openList: false,
        buttonString: '',
        selected: -1,
        current: -1,
    }), 2), state = _c[0], setState = _c[1];
    var openList = state.openList, buttonString = state.buttonString, selected = state.selected, current = state.current;
    React.useEffect(function () {
        var _a;
        if (openList) {
            if (current === -1) {
                return;
            }
            if (process.browser) {
                document.addEventListener("mouseup", handleMouseUp, false);
            }
            (_a = dataOptionsRef[current]) === null || _a === void 0 ? void 0 : _a.focus();
        }
        return function cleanup() {
            if (process.browser) {
                document.removeEventListener("mouseup", handleMouseUp, false);
            }
        };
    });
    var handleOpenList = function () {
        if (!state.openList) {
            setState(__assign(__assign({}, state), { openList: true, current: 0 }));
        }
    };
    var closeList = function () {
        var _a;
        if (state.openList) {
            setState(__assign(__assign({}, state), { openList: false }));
            (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
        }
    };
    var handleMouseUp = function (e) {
        var _a;
        if ((buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) !== null && ((_a = buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target))) {
            return;
        }
        else {
            closeList();
        }
    };
    var handleFocus = function () {
        if (onFocus) {
            onFocus(selected, buttonString);
        }
    };
    var handleBlur = function () {
        if (onBlur) {
            onBlur(selected, buttonString);
        }
    };
    var handleClick = function () {
        if (state.openList) {
            closeList();
        }
        else {
            handleOpenList();
        }
    };
    var handleSelect = function (index, item) {
        var _a;
        if (onChange) {
            onChange(index, item);
        }
        setState(__assign(__assign({}, state), { buttonString: item, openList: false, selected: index, current: index }));
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    };
    var keyDownSelect = function (e) {
        if (onKeyDown) {
            onKeyDown(e);
        }
        e.preventDefault();
        if (key_press_1.KeyPress.tabIsPressed(e)) {
            closeList();
        }
        else if (key_press_1.KeyPress.downArrowIsPressed(e)) {
            if (current < menuOptions.length - 1) {
                setState(__assign(__assign({}, state), { current: current + 1 }));
            }
        }
        else if (key_press_1.KeyPress.upArrowIsPressed(e)) {
            if (current > 0) {
                setState(__assign(__assign({}, state), { current: current - 1 }));
            }
        }
        else if (key_press_1.KeyPress.homeIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: 0 }));
        }
        else if (key_press_1.KeyPress.endIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: menuOptions.length - 1 }));
        }
        else if (key_press_1.KeyPress.pageUpIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current - 3 >= 0 ? current - 3 : 0 }));
        }
        else if (key_press_1.KeyPress.pageDownIsPressed(e)) {
            setState(__assign(__assign({}, state), { current: current + 3 < menuOptions.length ? current + 3 : menuOptions.length - 1 }));
        }
        else if (key_press_1.KeyPress.escIsPressed(e)) {
            closeList();
        }
        else if (key_press_1.KeyPress.enterIsPressed(e)) {
            handleSelect(current, menuOptions[current].optionItem);
        }
    };
    return (React.createElement("div", { "data-testid": testId, ref: ref },
        React.createElement("button", { "data-dropdown-target": "demo-dropdown-" + uniqueId, className: "btn-primary-2 btn-dropdown " + (buttonSize === 'small' ? 'btn-small' : ''), type: "button", "aria-pressed": "false", onClick: handleClick, onFocus: handleFocus, onBlur: handleBlur, ref: buttonRef, disabled: disabled === true },
            buttonTitle,
            React.createElement("span", { ref: function (element) {
                    if (element) {
                        element.style.setProperty('margin-left', '8px', 'important');
                    }
                }, className: (disabled === true ? styles.iconChevronGray : styles.iconChevronWhite) + " " + styles.animate + " height-sm-all width-sm-all .mar-l-xxs-sm " + (openList ? 'rotate180' : '') })),
        React.createElement("div", { className: "rel", style: { zIndex: openList ? 3 : -1 } },
            React.createElement("div", { id: "demo-dropdown-" + uniqueId, className: ["absolute z1 bg-ui-white border border-dark-gray radius-xs",
                    openList ? styles.dropdownOpen : styles.dropdownClose].join(' '), style: { 'minWidth': '200px' }, onKeyDown: keyDownSelect },
                React.createElement("ul", { role: "listbox" }, options === null || options === void 0 ? void 0 : options.menuOptions.map(function (item, index) {
                    return (React.createElement("li", { key: index, className: "option-list-item", role: "option", tabIndex: !openList ? -1 : current === index ? 0 : -1, "aria-selected": current === index, "aria-posinset": 1, ref: function (node) {
                            dataOptionsRef[index] = node;
                        }, onClick: handleSelect.bind(null, index, item.optionItem) }, item.optionItem));
                }))))));
});
exports.default = DropdownButton;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/DropdownButton/DropdownButton.js
// module id = 1769
// module chunks = 8